import { useEffect } from 'react';

function DataDeletion() {
  useEffect(() => {
    window.location.replace('/data-deletion.html');
  }, []);

  return null;
}

export default DataDeletion;
